export default {
      id: "imageSearch-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#imageSearch-usage",
      toString: function () {
        return this.url;
      }
    }